import React from 'react'
import { connect } from 'react-redux'
import { LoadMore, InfiniteLoader, Dialog, Toast } from 'react-weui'
import { bindActionCreators } from 'redux'
import * as relayAction from '../../actions/relays'
import RelayChannelListItem from './RelayChannelListItem'
import { WKVisible, InfiniteScroll } from '../../components'

class RelayChannelList extends React.Component {
    constructor(props) {
        super(props)
        this.primaryBtnStyle = {
            type: 'primary',
            label: '确定',
        }
        this.cancleBtnStyle = {
            type: 'default',
            label: '取消',
            onClick: () => this.onClickCancle()
        }
    }
    componentDidMount() {
        this.props.relaySetChannelKeyword(this.props.keyword || '')
        this.props.relayFetchChannelList()
    }
    handleTouchBottom(readyValue) {
        this.props.relayFetchChannelList()
    }
    renderChannelList(list) {
        return list.map(channel => {
            return (
                <RelayChannelListItem channel={channel} key={channel.id} />
            )
        })
    }
    onClickCreateLiveroom () {
        this.props.relaySetChannelCheckRes({})
        window.location = `/account/modify?redirect_url=/lecture/relay_confirm_new?id=${this.props.currentChannel.id}&type=channel`
    }
    onClickCancle () {
        this.props.relaySetChannelCheckRes({})
    }
    render() {
        const { channelList, channelHasMore, channelCheckRes: checkRes, tabId } = this.props
        if (tabId !== 1) return null
        if (channelList === null) return <LoadMore loading>正在加载</LoadMore>
        return (
            <div className='lecture-list-content'>
                {this.renderChannelList(channelList)}
                <WKVisible show={this.props.channelIsAsking && channelHasMore}>
                    <LoadMore loading>正在加载</LoadMore>
                </WKVisible>
                <WKVisible show={!channelHasMore} className='nomore-wrap'>
                    <LoadMore showLine>没有更多内容了</LoadMore>
                </WKVisible>
                <Toast icon="loading" iconSize='small' show={this.props.channelCheck}>正在检查</Toast>
                <Dialog type="ios" title='温馨提示' show={checkRes.code === 1 || checkRes.code === 2 || checkRes.code === 4 || checkRes.code === 5}
                    buttons={[{ ...this.primaryBtnStyle, onClick: () => this.onClickCancle() }]}>
                    {checkRes.msg}
                </Dialog>
                <Dialog type="ios" title='温馨提示' show={checkRes.code === 3}
                    buttons={[this.cancleBtnStyle, { ...this.primaryBtnStyle, onClick: e => this.onClickCreateLiveroom() }]}
                >
                    {checkRes.msg}
                </Dialog>
                <InfiniteScroll 
                    onTouchBottom={() => this.handleTouchBottom()}
                    isStop={this.props.channelIsAsking || this.props.tabId !== 1}
                    distance={100}
                />
            </div>
        )
    }
}

export default connect(state => ({
    channelList: state.relay.channelList,
    channelHasMore: state.relay.channelHasMore,
    tabId: state.component.wkTab.selectId,
    channelCheck: state.relay.channelCheck,
    channelCheckRes: state.relay.channelCheckRes,
    currentChannel: state.relay.currentChannel,
    channelIsAsking: state.relay.channelIsAsking,
}), dispatch => bindActionCreators({ ...relayAction }, dispatch))(RelayChannelList)


// WEBPACK FOOTER //
// ./src/components/relays/RelayChannelList.js